<div class="p-3" *ngIf="payload" [innerHTML]="(payload.notes ? payload.notes : '') | safeHtml"></div>
